import styled from "styled-components";
const RewardBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  position: relative;
  padding: 1rem;
  border-radius: 5px;
  background: ${props => props.theme.backgrounds.boxBG};
  margin: 1rem;
  width: calc(100% - 2em);

  & > div {
    padding-bottom: 1rem;
    margin-bottom: 1rem;
    &:before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      height: 1px;
      width: calc(100% - 1.5em);
      background: ${props => props.theme.colors.linkBorder};
      margin-left: 1rem;
    }
  }
`;

export default RewardBoxWrapper;
